<template>
    <div>
        <v-row dense>
            <v-col cols="12">
                <h4>{{ $t('additional_info') }}</h4>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12">
                <LabelField
                    :label="$t('interessen_tags_erweiterte_suche')"
                    :label-tip="$t('interessen_tags_erweiterte_suche_tip')"
                >
                    <TagSelect
                        :value="record.tags"
                        :placeholder="$t('placeholder_schedule_tags')"
                        item-value="tag"
                        clearable
                        for-schedule
                        show-download
                        hide-details="auto"
                        @input="onInput('tags', $event)"
                    />
                </LabelField>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="6">
                <LabelField :label="$t('terminstatus')" :label-tip="$t('terminstatus_label_tip')">
                    <ScheduleStatusSelect
                        :value="record.schedule_status_id"
                        :placeholder="$t('geplant')"
                        @input="onInput('schedule_status_id', $event)"
                    />
                </LabelField>
            </v-col>
            <v-col v-if="!isRecuringExhibition" cols="6" align-self="center">
                <v-checkbox
                    class="ml-5"
                    :input-value="record.is_sold_out"
                    :label="$t('sold_out')"
                    hide-details
                    @change="onInput('is_sold_out', $event)"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { Schedule } from '@/models/Schedule';
import { Event } from '@/models/Event';
import TagSelect from '@/components/tag/select';
import ScheduleStatusSelect from '@/components/schedule_status/Select.vue';

/**
 * This component defines the 3 rows containing the "Additinal Infos" for the Schedule Edit card.
 * For better readabibily and placing we put it in its own component.
 *
 * @see schedule.EditDialog.vue for the main component
 */

export default {
    name: 'ScheduleEditAdditionalInfoContainer',
    components: {
        TagSelect,
        ScheduleStatusSelect,
    },
    props: {
        event: Event,
        record: Schedule,
        isRecuringExhibition: Boolean,
    },

    methods: {
        onInput(field, value) {
            this.record.set(field, value);
        },

        showAdditionalOpeningHoursField() {
            if (this.record.isRecurring && this.event.event_class === Event.CLASS_EXHIBITION) {
                return true;
            }

            return false;
        },
    },
};
</script>
